<template>
  <!-- 对账单 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="carrierStatement"
          >确认对账</el-button
        >
        <!-- <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="cancelCarrierStatement"
          >取消对账</el-button
        > -->
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="printBtns">打印</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                class="rbtns"
                :disabled="
                  scope.row.customerReconciliationStatus ==
                  'yi_dui_zhan:customer_reconciliation_status'
                "
                @click.stop="carrierStatement(scope.row)"
                >确认对账</el-button
              >
              <el-button class="rbtns" @click.stop="getDetails(scope.row)"
                >查看详情</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                  class="rbtns"
                  @command="handleCommandBtns($event, scope.row)"
                >
                  <el-button type="primary">
                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">详情</el-dropdown-item>
                    <el-dropdown-item command="b">外发录入</el-dropdown-item>
                    <el-dropdown-item command="c">改运单号</el-dropdown-item>
                    <el-dropdown-item command="d">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 单票派车 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      :showConfirm1="true"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch('SAVE')"
      @diaConfirmBtn1="diaConfirmBtnDispatch('DISPATCH ')"
    >
      <div class="formbox" v-if="isShowDialogDispatch">
        <el-form class="glo_formBox" label-width="120px">
          <el-form-item label="车辆分类:">
            <el-select
              filterable
              clearable
              v-model="dialogFormDispatch.carCategoryConfDictId"
              placeholder="请选择"
              @change="changecarCategoryConfDictId"
            >
              <el-option
                v-for="(item, index) in car_categoryList"
                :key="index"
                :label="item.key"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否牵引车:">
            <el-select
              filterable
              clearable
              v-model="dialogFormDispatch.isTractor"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in isTractorList"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item required label="车牌号码:">
            <el-select
              filterable
              clearable
              allow-create
              remote
              v-model="dialogFormDispatch.carNumber"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in carNumberList1"
                :key="index"
                :label="item.carNumber"
                :value="item.carNumber"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="挂车号码:">
            <el-select
              v-model="dialogFormDispatch.trailerNumber"
              :remote-method="(e) => getcarNumberRmethod(e)"
              filterable
              clearable
              allow-create
              remote
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in carNumberList2"
                :key="index"
                :label="item.carNumber"
                :value="item.carNumber"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item required class="dialogTims" label="预计发车日期:">
            <el-date-picker
              v-model="dialogFormDispatch.planDepartureTime"
              class="input"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item required label="司机一:">
            <el-select
              filterable
              clearable
              v-model="dialogFormDispatch.driverOneId"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in driverList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item required label="司机一电话:">
            <el-input
              v-model="dialogFormDispatch.driverOnePhone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="司机一身份证:">
            <el-input
              v-model="dialogFormDispatch.driverOneIdcard"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="司机二:">
            <el-select
              filterable
              clearable
              v-model="dialogFormDispatch.driverTwoId"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in driverList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="司机二电话:">
            <el-input
              v-model="dialogFormDispatch.driverTwoPhone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="司机二身份证:">
            <el-input
              v-model="dialogFormDispatch.driverTwoIdcard"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="押运员一:">
            <el-select
              v-model="dialogFormDispatch.supercargoOneId"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in driverList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="押运员二:">
            <el-select
              v-model="dialogFormDispatch.supercargoTwoId"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in driverList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="随车人员一:">
            <el-select
              v-model="dialogFormDispatch.carFollowPersonnelOneId"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in driverList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="随车人员二:">
            <el-select
              v-model="dialogFormDispatch.carFollowPersonnelTwoId"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in driverList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预计总费用:">
            <el-input
              v-model="dialogFormDispatch.totalAmount"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="发车合同号:">
            <el-input
              v-model="dialogFormDispatch.dispatchContractNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input
              type="textarea"
              v-model="dialogFormDispatch.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- ======================打印组件======================== -->
    <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>
    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="调度配载模块"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleOk"
    ></printDialog>
    <!-- 创建和使用模板 -->
    <printSys
      :printForm="printForm"
      :title="printTitle"
      icon="el-icon-printer"
      @handleClose="handlePrintSysClose"
    >
      <printSysContent
        :printType="printType"
        :modelObj="modelObj"
        :modelClassName="modelClassName"
        :selectTableData="selectTableData"
      ></printSysContent>
    </printSys>
    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select v-model="modelClassName" placeholder style="width: 100%">
        <el-option
          v-for="(value, key) in classNameArr"
          :key="key"
          :label="value.name"
          :value="value.val"
        ></el-option>
      </el-select>
    </classNameDialog>
    <!-- ======================打印组件======================== -->

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
  </div>
</template>
  <script>
import tableList from "@/pages/commonJS/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import myDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, mixin_print, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "对账单列表", //导出时默认文件名
        apiName: "/v1/common/query/runCustomerPageReport", //导出的数据列表接口名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "customer_statement_list", //  页面标识
      reportFiledsNumber: "customer_statement_list", // 动态 条件、表头
      // 打印插件 每个页面不一样的
      // 模板className
      idarrs: [],
      classNameArr: [
        // {
        //   name: "车辆成本付款清单",
        //   val: "com.bami.service.tms.v3.admin.print.vo.AdminCarCostPrintDataV3tmsVo",
        // },
        // {
        //   name: "发车配载清单",
        //   val: "com.bami.service.tms.v3.admin.print.vo.AdminDispatchPrintDataV3tmsVo",
        // },
      ],
      // 默认的模板类型
      modelClassName: "",

      isShowDialogDispatch: false,
      dialogTitleDispatch: "单票派车",
      diaWidthDispatch: "60%",
      dialogFormDispatch: {
        isTractor: 0,
      },
      driverList: [], //司机列表
      car_categoryList: [], //车辆分类
      isTractorList: [
        //是否牵引车
        { val: 0, name: "否" },
        { val: 1, name: "是" },
      ],
      carNumberList1: [], //车牌号码
      carNumberList2: [], //挂车号码
      isHaseMore: true,
    };
  },
  mounted() {
    // this.getConfDictValDownLists("car_category");
    // this.getObjectUserDownList("driver");
    // this.getcarNumberRmethod("");
  },
  watch: {},
  methods: {
    // 查看详情
    getDetails(row) {
      this.$router.push(
        "/WaybillManage/statementAccountDetails?statementId=" + row.statementId
      );
    },
    // 确认对账
    carrierStatement(row) {
      let ids = [];
      if (row) {
        ids = [row.statementId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要操作的数据");
          return false;
        }
        ids = this.selectTableData.map((item) => {
          return item.statementId;
        });
      }

      let param = {
        statementIds: ids,
      };
      this.$API.carrierStatement(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.queryBtn_ok();
      });
    },
    // 取消对账
    cancelCarrierStatement() {
      let ids = [];
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择需要操作的数据");
        return false;
      }
      ids = this.selectTableData.map((item) => {
        return item.statementId;
      });
      this.$confirm("确定要把所选的数据进行 取消对账 操作吗?", "提示")
        .then(() => {
          let param = {
            statementIds: ids,
          };
          this.$API.cancelCarrierStatement(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.queryBtn_ok();
          });
        })
        .catch(() => {});
    },

    clickSingleTicketDelivery(row) {
      this.dialogFormDispatch.id = row.id;
      this.dialogFormDispatch.orderType = row.orderType;
      this.isShowDialogDispatch = true;
    },
    handleCloseDiaDispatch() {
      this.isShowDialogDispatch = false;
      this.dialogFormDispatch = {
        isTractor: 0,
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch(saveType) {
      let {
        carFollowPersonnelOneId,
        carFollowPersonnelTwoId,
        driverOneId,
        driverTwoId,
        supercargoOneId,
        supercargoTwoId,
      } = this.dialogFormDispatch;
      this.dialogFormDispatch.saveType = saveType;
      this.dialogFormDispatch.carFollowPersonnelOneName =
        (carFollowPersonnelOneId &&
          this.driverList.filter(
            (item) => item.documentId == carFollowPersonnelOneId
          )[0].name) ||
        "";
      this.dialogFormDispatch.carFollowPersonnelTwoName =
        (carFollowPersonnelTwoId &&
          this.driverList.filter(
            (item) => item.documentId == carFollowPersonnelTwoId
          )[0].name) ||
        "";
      this.dialogFormDispatch.driverOneName =
        (driverOneId &&
          this.driverList.filter((item) => item.documentId == driverOneId)[0]
            .name) ||
        "";
      this.dialogFormDispatch.driverTwoName =
        (driverTwoId &&
          this.driverList.filter((item) => item.documentId == driverTwoId)[0]
            .name) ||
        "";
      this.dialogFormDispatch.supercargoOneName =
        (supercargoOneId &&
          this.driverList.filter(
            (item) => item.documentId == supercargoOneId
          )[0].name) ||
        "";
      this.dialogFormDispatch.supercargoTwoName =
        (supercargoTwoId &&
          this.driverList.filter(
            (item) => item.documentId == supercargoTwoId
          )[0].name) ||
        "";
      this.$API.takeoneDispatch(this.dialogFormDispatch).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialogDispatch = false;
        this.getData();
      });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownLists(val) {
      this.$COMAPI.getConfDictValDownList(val).then((res) => {
        //车辆分类
        if (val == "car_category") {
          this.car_categoryList = res || [];
        }
      });
    },
    // 获取车辆下拉列表(拿车牌号码)
    changecarCategoryConfDictId(e) {
      if (e) {
        this.$API
          .CarDownList({
            pageStart: 1,
            pageTotal: 200,
            carNumber: "",
            carCategoryConfDictId: e, //车辆分类id
          })
          .then((res) => {
            this.carNumberList1 = res.data.result.data || [];
          });
      }
    },
    // 获取车辆下拉列表(拿挂车号码)
    getcarNumberRmethod(e) {
      this.$API
        .CarArchiveList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: e || "",
        })
        .then((res) => {
          this.carNumberList2 = res.data.result.data || [];
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "driver") {
          this.driverList = res || [];
        }
      }); //获取网点列表
    },
    // ==================打印插件==================
    // 打印按钮
    printEvent(val) {
      let idarr = [];
      if (val) {
        idarr.push(val.dispatchId);
        this.selectTableData = [val];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要打印的数据");
          return false;
        }
        idarr = this.selectTableData.map((item) => {
          return item.dispatchId;
        });
      }
      console.log("idarr", idarr);
      this.idarrs = idarr;

      window.sessionStorage.setItem(
        "set_PrintSelectTableData",
        JSON.stringify(idarr)
      );
      this.dialogFrom.dialogVisible = true;
    },
    // 打印预览模板
    handleView(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || [];
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }

      if (obj.className == this.classNameArr[0].val) {
        // 获取车辆成本打印数据
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // 打印-确定模板的数据
    handleOk(obj) {
      console.log(obj, "obj");
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || [];
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }
      if (obj.className == this.classNameArr[0].val) {
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // ==================打印插件==================
  },
};
</script>
  <style scoped lang="less">
.textArea {
  height: auto !important;
}
</style>